module.exports = {"meta":{"ajaxType":"post","path":"/wantwant-server/kayzstock/list","type":"report","id":"sales_list","code":"sales_list","title":"KA银座库存表","buttons":[],"columns":[{"name":"accountId","title":"账户ID"},{"name":"downloadTime","title":"数据采集日期"},{"name":"id","title":"主键ID"},{"name":"prodBrand","title":"品牌"},{"name":"prodCode","title":"商品编码"},{"name":"publicDate","title":"发布日期"},{"name":"stockDate","title":"库存日期"},{"name":"stockQty","title":"库存数量"},{"name":"storeName","title":"门店名称"},{"name":"updatedTime","title":"修改日期"}],"params":[]}}


//////////////////
// WEBPACK FOOTER
// ./src/_app/wwka/src/views/sales/kayzstock.json
// module id = wVad
// module chunks = 63